import React from 'react';

import {
  HeaderWrap,
  Logo,
  LogoWrap,
  Nav,
  NavContents,
  NavItem,
} from './Header.style';

import ThemeToggle from '@/components/ThemeToggle/ThemeToggle';
import { NAV_LINK_ITEMS } from '@/constants/constants';
import useLogoImage from '@/hooks/useLogoImage';

function Header() {
  const logo = useLogoImage();

  return (
    <HeaderWrap>
      <Nav>
        <LogoWrap to="/">
          <Logo
            image={logo.childImageSharp.gatsbyImageData}
            alt="홈으로 이동"
          />
        </LogoWrap>
        <NavItem>
          {NAV_LINK_ITEMS.map(item => (
            <NavContents key={item.title} to={item.url} aria-label={item.title}>
              {item.title}
            </NavContents>
          ))}
          <ThemeToggle />
        </NavItem>
      </Nav>
    </HeaderWrap>
  );
}

export default Header;
